import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const IncidentSystemEntry = () => {
  useModuleRedirect("fire-safety-incident-admin");
  return null;
};

export default IncidentSystemEntry;
